<template>
  <nav class="navbar" role="navigation" aria-label="main navigation">
    <div class="navbar-brand">
      <router-link to='/' class="navbar-item">
        <img src="../assets/logo.png" width="28" height="28">
      </router-link>

      <a role="button" class="navbar-burger burger" aria-label="menu" :aria-expanded='navIsOpen ? "true" : "false"'
          @click="navIsOpen = !navIsOpen" v-bind:class="{'is-active': navIsOpen}">
        <span :aria-hidden='navIsOpen ? "false" : "true"'></span>
        <span :aria-hidden='navIsOpen ? "false" : "true"'></span>
        <span :aria-hidden='navIsOpen ? "false" : "true"'></span>
      </a>
    </div>

    <div class="navbar-menu" v-bind:class="{'is-active': navIsOpen}">
      <div class="navbar-start">
        <div class="navbar-item">
          <router-link to='/create/event' class="button is-primary">
            <span class="icon">
              <i class="fas fa-plus"></i>
            </span>
            <span><strong>Create Event</strong></span>
          </router-link>
        </div>
        <!-- <router-link to='/search/event' class="navbar-item">
          <span class="icon">
            <i class="fas fa-search-location"></i>
          </span>
          <span>Find Events</span>
        </router-link> -->
      </div>

      <div class="navbar-end">
        <template v-if="isSignedIn">
          <div class="navbar-item has-dropdown is-hoverable">
            <a class="navbar-link">
              <span class="icon">
                <i class="fas fa-user"></i>
              </span>
              <span>{{userInfo.username}}</span>
            </a>

            <div class="navbar-dropdown">
              <router-link :to="`/profile/${userInfo.attributes.sub}/${userInfo.username}`" class="navbar-item">
                <span class="icon">
                  <i class="fas fa-id-card"></i>
                </span>
                <span>Profile</span>
              </router-link>
              <hr class="navbar-divider">
              <a class="navbar-item" v-on:click='signOut'>
                <span class="icon">
                  <i class="fas fa-sign-out-alt"></i>
                </span>
                <span>Sign Out</span>
              </a>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="navbar-item">
            <div class="buttons">
              <router-link to='/signup' class="button is-primary">
                <span class="icon">
                  <i class="fas fa-user-plus"></i>
                </span>
                <span><strong>Sign up</strong></span>
              </router-link>
              <router-link to='/signin' class="button is-light">
                <span class="icon">
                  <i class="fas fa-sign-in-alt"></i>
                </span>
                <span>Sign in</span>
              </router-link>
            </div>
          </div>
        </template>
      </div>
    </div>
  </nav>
</template>
<script>
import { AmplifyEventBus } from 'aws-amplify-vue';

export default {
  name: 'Header',
  props: ['userInfo', 'isSignedIn'],
  data: function() {
    return {
      navIsOpen: false,
    };
  },
  methods: {
    signOut: function() {
      this.$Amplify.Auth.signOut().then(() => {
        return AmplifyEventBus.$emit('authState', 'signedOut');
      }).catch(e => {
        this.setError(e)
      });
    },
    setError: function(e) {
      this.error = this.$Amplify.I18n.get(e.message || e);
      this.logger.error(this.error);
    }
  }
};
</script>
<style>
</style>